var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import BaseModel from './base_model';
import { deserializeString } from "../common";
import { Resource } from '../annotations';
let Contact = class Contact extends BaseModel {
    constructor(_data) {
        const data = _data || {};
        super(data);
        this.name = deserializeString(data.name);
        this.street = deserializeString(data.street || data.address);
        this.street2 = deserializeString(data.street2);
        this.zip = deserializeString(data.zip || data.zipCode);
        this.city = deserializeString(data.city);
        this.country = deserializeString(data.country);
        this.email = deserializeString(data.email);
        this.phone = deserializeString(data.phone);
        this.site = deserializeString(data.site);
        this.isActive = data.isActive || false;
        this.note = deserializeString(data.note);
        this.firstName = deserializeString(data.firstName);
        this.lastName = deserializeString(data.lastName);
        // VatAddressable
        this.businessId = deserializeString(data.businessId);
        this.vatId = deserializeString(data.vatId);
        this.vatPayerId = deserializeString(data.vatPayerId);
    }
    getName() {
        return this.name || this.fullName;
    }
    get fullName() {
        return [this.firstName, this.lastName].filter(f => f && f.length > 0).join(' ');
    }
};
Contact = __decorate([
    Resource('contacts'),
    __metadata("design:paramtypes", [Object])
], Contact);
export default Contact;
//# sourceMappingURL=contact.js.map